import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { Action } from 'redux';
import { CreateDialog } from '../../ui/action-creators';
import store from '../../index';
import { LoadRelease, ConfirmCancelReleaseChanges } from '../action-creators';
import { CONFIRM_CANCEL_RELEASE_CHANGES } from '../actions';

export const confirmCancelReleaseChangesEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, ConfirmCancelReleaseChanges>(CONFIRM_CANCEL_RELEASE_CHANGES),
    map((action) => {
      return new CreateDialog(`CancelChanges.${action.releaseId}`, {
        open: true,
        title: `All changes will be lost!`,
        text: `If you cancel the changes the release will retain its status and won't be resubmitted.`,
        actions: [
          { type: "secondary", label: "Go Back", value: false },
          { type: "primary", label: "Cancel Changes", value: true },
        ],
        callback: (result) => result && store.dispatch(new LoadRelease(action.artistId, action.releaseId))
      })
    })
  )